module.exports = __webpack_public_path__ + "static/media/lounge_ageas_2.3d3d9c51.jpg";